module.exports = __webpack_public_path__ + "img/activity_other4.96b98569.jpg";